export namespace HttpConstants {
  export const ACCEPT = "accept";
  export const APPLICATION_JSON = "application/json";
  export const CONTENT_TYPE = "Content-Type";
  export type RESPONSE_TYPES =
    | "arraybuffer"
    | "blob"
    | "document"
    | "json"
    | "text"
    | "stream";
  export const WEB = "web";          
  export const APP_ID = "APP_ID";   
  export const APP_ID_VALUE = WEB;   
}
